// copy from task.ts
// 减少client.ts编译体积
export class TaskSource {
    _promise;
    _resolve;
    _reject;
    _fired = false;
    constructor() {
        this._promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get Promise() {
        return this._promise;
    }
    Resolve(t) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._resolve(t);
    }
    // todo
    TryResolve(t) {
        if (this._fired) {
            return false;
        }
        this.Resolve(t);
    }
    Reject(e) {
        if (this._fired) {
            console.error('Can not Resolve fired source');
            return;
        }
        this._fired = true;
        this._reject(e);
    }
    get Fired() {
        return this._fired;
    }
}
export function sleep(timeout) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, timeout);
    });
}
const cancelExceptionSymbol = '$$CancelExceptionSymbol';
export class CancelException extends Error {
    cls = cancelExceptionSymbol;
}
export function isCancelException(e) {
    return e && e.cls === cancelExceptionSymbol;
}
export var E_ServerCommand;
(function (E_ServerCommand) {
    E_ServerCommand["Submit"] = "register_embed:Submit";
    E_ServerCommand["RedirectTo"] = "register_embed:RedirectTo";
    E_ServerCommand["Ping"] = "register_embed:ping";
    E_ServerCommand["SwitchIframeResizerReply"] = "register_embed:switchIframeReizer:reply";
    E_ServerCommand["MessageBox"] = "register_embed:MessageBox";
})(E_ServerCommand || (E_ServerCommand = {}));
export var E_ClientCommand;
(function (E_ClientCommand) {
    E_ClientCommand["Pong"] = "register_embed:pong:reply";
    E_ClientCommand["SwitchIframeResizer"] = "register_embed:switchIframeReizer";
    E_ClientCommand["MessageBoxReply"] = "register_embed:MessageBoxReply";
})(E_ClientCommand || (E_ClientCommand = {}));
export class Channel {
    config;
    waittingCommands = {};
    constructor(config) {
        this.config = config;
    }
    maybeMarkAskResolved(uid, data) {
        if (this.waittingCommands[uid]) {
            this.waittingCommands[uid].task.Resolve(data);
            delete this.waittingCommands[uid];
        }
    }
    maybeMarkAskCanceled(uid) {
        if (this.waittingCommands[uid]) {
            this.waittingCommands[uid].task.Reject(new CancelException());
            delete this.waittingCommands[uid];
        }
    }
    ask(packet, options) {
        options = {
            single: false,
            ...options,
        };
        if (options.single) {
            for (const key in this.waittingCommands) {
                if (this.waittingCommands[key].request.command === packet.command) {
                    this.maybeMarkAskCanceled(packet.uid);
                }
            }
        }
        const uid = packet.uid;
        const taskSource = new TaskSource();
        this.waittingCommands[uid] = {
            task: taskSource,
            request: packet,
        };
        this.fire(packet);
        return taskSource.Promise;
    }
    fire(packet) {
        this.config.window.postMessage(packet, '*');
    }
}
